export default __webpack_public_path__ + "a237c9d28db9a9deca1b45e56026cd14.gif";